// src/utils/cloudinaryUpload.js
export const uploadToCloudinary = async (file) => {
  if (!file) throw new Error("File tidak boleh kosong");

  const url = process.env.REACT_APP_CLOUDINARY_URL_UPLOAD; // https://api.cloudinary.com/v1_1/<CLOUD_NAME>/image/upload
  const uploadPreset = "react_upload"; // pastikan sudah ada di Cloudinary → Settings → Upload → Upload Presets

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", uploadPreset);

  try {
    const res = await fetch(url, {
      method: "POST",
      body: formData,
    });

    if (!res.ok) {
      const text = await res.text(); // ambil response body jika error
      console.error("Cloudinary error response:", text);
      throw new Error("Upload Cloudinary gagal");
    }

    const data = await res.json();
    console.log("Cloudinary upload success:", data);
    // return URL dan nama file
    return {
      imageUrl: data.secure_url,
      namaBanner: data.original_filename,
    };
  } catch (err) {
    console.error("Upload Cloudinary error:", err);
    throw new Error("Upload Cloudinary gagal");
  }
};
